import { Admin, CustomRoutes, Resource } from 'react-admin';
import authProvider from './authProvider';
import CustomLayout from './customStyles/CustomLayout';
import { myTheme } from './customStyles/customTheme';
import './App.css';
import InvoiceList from './invoices/InvoiceList';
import CustomerList from './customers/CustomerList';
import InvoiceCreate from './invoices/InvoiceCreate';
import CustomerEdit from './customers/CustomerEdit';
import CustomerCreate from './customers/CustomerCreate';
import CustomerShow from './customers/CustomerShow';
import { i18nProvider } from './i18nProvider';
import InvoiceShow from './invoices/InvoiceShow';
import ProductList from './products/ProductList';
import ProductCreate from './products/ProductCreate';
import DraftList from './drafts/DraftList';
import DraftShow from './drafts/DraftShow';
import DraftCreate from './drafts/DraftCreate';
import DraftEdit from './drafts/DraftEdit';
import ProductEdit from './products/ProductEdit';
import NumberRangeList from './numberRanges/NumberRangeList';
import NumberRangeCreate from './numberRanges/NumberRangeCreate';
import UserShow from './users/UserShow';
import UserEdit from './users/UserEdit';
import { Task, TextSnippet, People, Inventory, Filter1, DeleteForever, AccessAlarm } from '@mui/icons-material';
import { Route } from 'react-router-dom';
import UserLogo from './users/UserLogo';
import UserMailServiceConfig from './users/UserMailServiceConfig';
import MailServiceConfigEdit from './users/mailServiceConfig/MailServiceConfigEdit';
import UserTextModel from './users/UserTextModel';
import TextModelEdit from './users/textModel/TextModelEdit';
import ReverseInvoiceShow from './reverseInvoices/ReverseInvoiceShow';
import NumberRangeEdit from './numberRanges/NumberRangeEdit';
import { useEffect, useState } from 'react';
import { HubConnection } from '@microsoft/signalr';
import dataProvider from './dataProvider';
import connectToHub from './hubs/connectToHub';
import MailTextEdit from './users/mailServiceConfig/MailTextEdit';
import InvoiceReminderShow from './invoiceReminders/InvoiceReminderShow';
import InvoiceReminderList from './invoiceReminders/InvoiceReminderList';
import ReverseInvoiceList from './reverseInvoices/ReverseInvoiceList';
import XmlInvoicePreview from './xmlInvoices/XmlInvoicePreview';
import Dashboard from './dashboard/Dashboard';
import { LoginPage } from './authentication/LoginPage';

const App = () => {
  const [connections, setConnections] = useState<{
    invoiceHub?:HubConnection,
    reverseInvoiceHub?: HubConnection, 
    invoiceReminderHub?: HubConnection,
    customerHub?:HubConnection,
    numberRangeHub?:HubConnection,
    userHub?:HubConnection
  }>()
  const setHubConnections = async() => {
    const userHub = await connectToHub('userHub')
    const invoiceHub = await connectToHub('invoiceHub')
    const reverseInvoiceHub = await connectToHub('reverseInvoiceHub')
    const numberRangeHub = await connectToHub('numberRangeHub')
    const customerHub = await connectToHub('customerHub')
    const invoiceReminderHub = await connectToHub('invoiceReminderHub')
    setConnections({
      userHub: userHub,
      invoiceHub: invoiceHub,
      reverseInvoiceHub: reverseInvoiceHub,
      numberRangeHub: numberRangeHub,
      customerHub: customerHub,
      invoiceReminderHub: invoiceReminderHub
    })
  }
  useEffect(() => {
    !connections && setHubConnections()
  }, [])

  return (
    <Admin
      dashboard={() => <Dashboard connection={connections?.invoiceHub} />}
      disableTelemetry 
      loginPage={<LoginPage />}
      authProvider={authProvider}
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      layout={CustomLayout}
      theme={myTheme}
      requireAuth
    >
      <Resource 
        name='invoices' 
        icon={Task} 
        list={<InvoiceList connections={{invoiceHub: connections?.invoiceHub, reverseInvoiceHub: connections?.reverseInvoiceHub}} />} 
        show={<InvoiceShow />} 
        create={<InvoiceCreate />}
      />
      <Resource name='drafts' icon={TextSnippet} list={<DraftList />} show={<DraftShow />} edit={<DraftEdit />} create={<DraftCreate />} />
      <Resource name='customers' icon={People} list={<CustomerList connection={connections?.customerHub} />} show={<CustomerShow />} edit={<CustomerEdit />} create={<CustomerCreate />} />
      <Resource name='products' icon={Inventory} list={<ProductList />} create={<ProductCreate />} edit={<ProductEdit />} />
      <Resource name='numberRanges' icon={Filter1} list={<NumberRangeList connection={connections?.numberRangeHub} />} create={<NumberRangeCreate />} edit={<NumberRangeEdit />} />
      <Resource name='users' show={<UserShow connection={connections?.userHub} />} edit={<UserEdit />} >
        <Route path=':userId/logo' element={<UserLogo connection={connections?.userHub} />} />
        <Route path=':userId/mailServiceConfig/*' element={<UserMailServiceConfig connection={connections?.userHub} />} />
        <Route path=':userId/mailServiceConfig/edit' element={<MailServiceConfigEdit />} />
        <Route path=':userId/mailServiceConfig/edit/1' element={<MailTextEdit />} />
        <Route path=':userId/textModel' element={<UserTextModel connection={connections?.userHub} />} />
        <Route path=':userId/textModel/edit' element={<TextModelEdit />} />
      </Resource>
      <Resource name='files' />
      <Resource name='cars' />
      <Resource name='expenditureAccounts' />
      <Resource name='revenuesAccounts' />
      <Resource 
        name='reverseInvoices' 
        icon={DeleteForever} 
        list={<ReverseInvoiceList connection={connections?.reverseInvoiceHub} />} 
        show={<ReverseInvoiceShow />} 
      />
      <Resource 
        name='invoiceReminders' 
        icon={AccessAlarm} 
        list={<InvoiceReminderList connection={connections?.invoiceReminderHub} />} 
        show={<InvoiceReminderShow />} 
      />
      <CustomRoutes>
        <Route path='xmlInvoices' element={<XmlInvoicePreview />} />
      </CustomRoutes>
    </Admin>
  )
 
}

export default App